// ===================== CONTACTS MAP =====================

document.addEventListener('DOMContentLoaded', function() {
  // Проверяем, есть ли контейнер карты на странице
  const mapContainer = document.getElementById('contactsMap');
  if (!mapContainer) return;

  const cities = [
    { name: 'Москва', coords: [55.7558, 37.6173] },
    { name: 'Санкт-Петербург', coords: [59.9343, 30.3351] },
    { name: 'Новосибирск', coords: [55.0084, 82.9357] },
    { name: 'Екатеринбург', coords: [56.8389, 60.6057] },
    { name: 'Казань', coords: [55.7887, 49.1221] },
    { name: 'Нижний Новгород', coords: [56.2965, 43.9361] },
    { name: 'Челябинск', coords: [55.1644, 61.4368] },
    { name: 'Самара', coords: [53.1959, 50.1002] },
    { name: 'Омск', coords: [54.9914, 73.3715] },
    { name: 'Ростов-на-Дону', coords: [47.2357, 39.7015] },
    { name: 'Уфа', coords: [54.7351, 55.9587] },
    { name: 'Красноярск', coords: [56.0106, 92.8526] },
    { name: 'Пермь', coords: [58.0104, 56.2294] },
    { name: 'Воронеж', coords: [51.6605, 39.2003] },
    { name: 'Волгоград', coords: [48.7075, 44.5143] },
    { name: 'Краснодар', coords: [45.0355, 38.9753] },
    { name: 'Саратов', coords: [51.5336, 46.0342] },
    { name: 'Тюмень', coords: [57.1535, 65.5342] },
    { name: 'Тольятти', coords: [53.5078, 49.4204] },
    { name: 'Барнаул', coords: [53.3546, 83.7490] },
    { name: 'Ижевск', coords: [56.8528, 53.2118] },
    { name: 'Хабаровск', coords: [48.4802, 135.0719] },
    { name: 'Владивосток', coords: [43.1155, 131.8855] },
    { name: 'Ярославль', coords: [57.6261, 39.8845] },
    { name: 'Махачкала', coords: [42.9849, 47.5046] },
    { name: 'Оренбург', coords: [51.7682, 55.0968] },
    { name: 'Кемерово', coords: [55.3547, 86.0892] },
    { name: 'Новокузнецк', coords: [53.7596, 87.1216] },
    { name: 'Рязань', coords: [54.6269, 39.6916] },
    { name: 'Томск', coords: [56.4884, 84.9523] },
    { name: 'Астрахань', coords: [46.3496, 48.0408] },
    { name: 'Набережные Челны', coords: [55.7436, 52.3959] },
    { name: 'Пенза', coords: [53.1945, 45.0195] },
    { name: 'Липецк', coords: [52.6071, 39.5992] },
    { name: 'Киров', coords: [58.6039, 49.6680] }
  ];

  const map = L.map('contactsMap', {
    zoomControl: false,
    attributionControl: false
  });

  L.control.zoom({ position: 'topright' }).addTo(map);

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19
  }).addTo(map);

  const customIcon = L.divIcon({
    className: 'custom-marker-wrapper',
    html: '<div class="custom-marker"></div>',
    iconSize: [20, 20],
    iconAnchor: [10, 10],
    popupAnchor: [0, -20]
  });

  const markerGroup = L.featureGroup();

  cities.forEach(city => {
    L.marker(city.coords, { icon: customIcon })
      .bindPopup(`<strong>${city.name}</strong>`, { className: 'custom-popup' })
      .addTo(markerGroup);
  });

  markerGroup.addTo(map);

  function fitMapToMarkers() {
    map.invalidateSize();
    map.fitBounds(markerGroup.getBounds(), {
      padding: [20, 20]
    });
  }

  setTimeout(fitMapToMarkers, 300);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fitMapToMarkers, 300);
  });

  window.addEventListener('orientationchange', () => {
    setTimeout(fitMapToMarkers, 300);
  });
});
